import { useState } from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import { Icon } from '@iconify/react';
import { Popover, PopoverContent, PopoverTrigger } from 'base/src/components/Popover';
import { LotePedidoResponse } from '../../../../types/lotePedido/lotePedidoResponse';

interface LoteActionsPopoverProps {
  item: LotePedidoResponse;
  campanhaId: number;
  onAction: (action: string, item: LotePedidoResponse) => void;
  onPopoverOpenChange: (open: boolean) => void;
}

export function LoteActionsPopover({ item, onAction, onPopoverOpenChange }: LoteActionsPopoverProps) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  // const navigate = useNavigate();

  // function navegarNotaRepasse() {
  //   if (campanhaId) {
  //     RedirectWithRouter(navigate, "notaRepasse", [
  //       { key: CampanhaParameters.campanhaId, value: campanhaId },
  //       { key: 'CampanhaPedidoResgatePagamentoID', value: item.CampanhaPedidoResgatePagamentoID }
  //     ]);
  //   }
  //   closePopover();
  // }

  function closePopover() {
    setIsPopoverOpen(false);
    onPopoverOpenChange(false);
  }

  function handlePopoverOpenChange(open: boolean) {
    setIsPopoverOpen(open);
    onPopoverOpenChange(open);
  }

  function handleAction(actionType: string) {
    onAction(actionType, item);
    closePopover();
  }

  function handleAdicionarSaldo() {
    handleAction('adicionar-saldo');
  }

  function handleDetalhesPagamento() {
    handleAction('detalhes-pagamento');
  }
  function handleNotaRepasse() {
    handleAction('nota-repasse');
  }

  function handleEfetuarPagamento() {
    handleAction('efetuar-pagamento');
  }

  function handleBaixarNotas() {
    handleAction('baixar-notas');
  }

  function handleExcluir() {
    handleAction('excluir');
  }

  return (
    <Popover open={isPopoverOpen} onOpenChange={handlePopoverOpenChange}>
      <PopoverTrigger asChild>
        <Box
          component="button"
          sx={{
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 1,
            borderRadius: 1,
            '&:hover': {
              backgroundColor: 'grey.100'
            }
          }}
        >
          <Icon icon='mdi:dots-vertical' width={22} height={22} />
        </Box>
      </PopoverTrigger>

      <PopoverContent
        side="left"
        align="start"
      >
        <List sx={{ py: 1 }}>
          {/* Adicionar Saldo */}
          <ListItem
            component="button"
            onClick={handleAdicionarSaldo}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: 'grey.50'
              },
              border: 'none',
              background: 'none',
              width: '100%',
              textAlign: 'left'
            }}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              <Typography sx={{ fontSize: '1.2rem' }}>💰</Typography>
            </ListItemIcon>
            <ListItemText
              primary="Adicionar Saldo"
              primaryTypographyProps={{
                variant: 'body2',
                fontWeight: 500
              }}
            />
          </ListItem>

          {/* Nota de Repasse */}
          <ListItem
            component="button"
            onClick={handleNotaRepasse}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: 'grey.50'
              },
              border: 'none',
              background: 'none',
              width: '100%',
              textAlign: 'left'
            }}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              <Typography sx={{ fontSize: '1.2rem' }}>📄</Typography>
            </ListItemIcon>
            <ListItemText
              primary="Nota de Repasse"
              primaryTypographyProps={{
                variant: 'body2',
                fontWeight: 500
              }}
            />
          </ListItem>

          {/* Detalhes do Pagamento */}
          <ListItem
            component="button"
            onClick={handleDetalhesPagamento}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: 'grey.50'
              },
              border: 'none',
              background: 'none',
              width: '100%',
              textAlign: 'left'
            }}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              <Typography sx={{ fontSize: '1.2rem' }}>📋</Typography>
            </ListItemIcon>
            <ListItemText
              primary="Detalhes Pagamento"
              primaryTypographyProps={{
                variant: 'body2',
                fontWeight: 500
              }}
            />
          </ListItem>

          {/* Efetuar Pagamento - só aparece quando status = 1 ou 5 */}
          {(item.CampanhaPedidoResgatePagamentoStatusID === 1 || item.CampanhaPedidoResgatePagamentoStatusID === 5) && (
            <>
              <Divider sx={{ my: 1 }} />
              <ListItem
                component="button"
                onClick={handleEfetuarPagamento}
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: 'success.50'
                  },
                  border: 'none',
                  background: 'none',
                  width: '100%',
                  textAlign: 'left'
                }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <Typography sx={{ fontSize: '1.2rem' }}>💳</Typography>
                </ListItemIcon>
                <ListItemText
                  primary="Efetuar Pagamento"
                  primaryTypographyProps={{
                    variant: 'body2',
                    fontWeight: 600,
                    color: 'success.main'
                  }}
                />
              </ListItem>
            </>
          )}

          {/* Baixar Notas Fiscais - só aparece quando status = 3 */}
          {item.CampanhaPedidoResgatePagamentoStatusID === 3 && (
            <>
              <Divider sx={{ my: 1 }} />
              <ListItem
                component="button"
                onClick={handleBaixarNotas}
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: 'info.50'
                  },
                  border: 'none',
                  background: 'none',
                  width: '100%',
                  textAlign: 'left'
                }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <Typography sx={{ fontSize: '1.2rem' }}>📄</Typography>
                </ListItemIcon>
                <ListItemText
                  primary="Baixar Notas Fiscais"
                  primaryTypographyProps={{
                    variant: 'body2',
                    fontWeight: 500,
                    color: 'info.main'
                  }}
                />
              </ListItem>
            </>
          )}

          {/* Excluir - só aparece quando status = 1 */}
          {item.CampanhaPedidoResgatePagamentoStatusID === 1 && (
            <>
              <Divider sx={{ my: 1 }} />
              <ListItem
                component="button"
                onClick={handleExcluir}
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: 'error.50'
                  },
                  border: 'none',
                  background: 'none',
                  width: '100%',
                  textAlign: 'left'
                }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <Typography sx={{ fontSize: '1.2rem' }}>🗑️</Typography>
                </ListItemIcon>
                <ListItemText
                  primary="Excluir"
                  primaryTypographyProps={{
                    variant: 'body2',
                    fontWeight: 500,
                    color: 'error.main'
                  }}
                />
              </ListItem>
            </>
          )}
        </List>
      </PopoverContent>
    </Popover>
  );
}
